import { Injectable } from '@angular/core';
import { ActiveCartService, CartAdapter } from '@spartacus/cart/base/core';
import { WindowRef } from '@spartacus/core';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { KnBrCommonService } from '../services/kn-br-common.service';
import { KnBrCartContextService } from '../store/kn-br-cart-context/kn-br-cart-context.service';

@Injectable({
  providedIn: 'root',
})
export class SalesCartPagelayoutHandler implements PageLayoutHandler {
  constructor(
    protected activeService: ActiveCartService,
    protected cartAdapter: CartAdapter,
    protected winRef: WindowRef,
    protected commonService: KnBrCommonService,
    private knBrCartContextService: KnBrCartContextService
  ) {}

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string) {
    if (pageTemplate === 'CarlisleSalesCartsPageTemplate' && !section) {
      this.commonService.showSpinner$.next(true);

      const entries$ = this.knBrCartContextService.get$.pipe(
        switchMap((cartId) => {
          if (!cartId) {
            return of([]);
          }
          return this.cartAdapter.loadAll('current').pipe(
            map((carts) => {
              const firstCart = carts && carts.length ? carts[0] : null;
              return firstCart && Array.isArray(firstCart.entries) ? firstCart.entries : [];
            }),
            catchError(() => of([]))
          );
        })
      );

      return combineLatest([
        slots$,
        entries$,
        this.activeService.getLoading(),
      ]).pipe(
        map(([slots, entries, loadingCart]) => {
          const exclude = (arr, args) => arr.filter((item) => args.every((arg) => arg !== item));
          this.commonService.showSpinner$.next(false);
          if (!this.winRef.isBrowser() || loadingCart) {
            return slots;
          }
          return entries.length > 0
            ? exclude(slots, ['BodyContent'])
            : exclude(slots, ['TopContent']);
        })
      );
    }
    return slots$;
  }

}
